import Default from "./BorderedListItem";
export * from "./BorderedListItem";

export default Default;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/BorderedListItem/index.ts